'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { cx } from '../../../internal/cx.js';
import { Dialog, DialogClose, DialogContent, DialogTrigger, } from '../dialog/index.js';
/**
 * A centred Dialog on wide screens and a bottom sheet on narrow ones, from one
 * API and one DOM. The switch is pure CSS (a media query), not `matchMedia`:
 * the server and the first client render are identical, so there is no
 * hydration mismatch and no flash of the wrong layout. Focus trap, Escape and
 * focus return are the Dialog's in both layouts.
 *
 * Compose it with the Dialog parts: DialogHeader, DialogTitle,
 * DialogDescription, DialogBody and DialogFooter.
 */
export const ResponsiveDialog = Dialog;
export const ResponsiveDialogTrigger = DialogTrigger;
export const ResponsiveDialogClose = DialogClose;
export const ResponsiveDialogContent = forwardRef(function ResponsiveDialogContent({ sheetBelow = 'sm', handle = true, className, children, ...rest }, ref) {
    return (_jsxs(DialogContent, { ref: ref, ...rest, "data-sheet-below": sheetBelow, className: cx('mn-responsive-dialog', className), children: [handle ? _jsx("div", { className: "mn-responsive-dialog__handle", "aria-hidden": true }) : null, children] }));
});
//# sourceMappingURL=responsive-dialog.js.map